import React from 'react'
import Home from './home/Home'
import Container from './container/Container'



function Landingpage() {
  return (
    <div>
      <Container>
    <Home/> 
    </Container>
    </div>
  )
}

export default Landingpage
